import React from 'react'
import { Input } from '@chakra-ui/react'

const SelectCountingAdd = ({ handleChange, selectedId, items, placeholder, type }) => {


    const selectedName = items.find(item => item._id === selectedId)?.name || ''

    const onChange = (e) => {
        const value = e.target.value
        const option = e.target.list ? Array.from(e.target.list.options).find(option => option.value === value) : null
        const id = option ? option.getAttribute('data-value') : value
        handleChange({ target: { value: id } })
    }

    return (
        <><Input id={`add_${type}`} list={`counting_add_list_${type}`} placeholder={placeholder} value={selectedName} onChange={onChange}/>
            <datalist id={`counting_add_list_${type}`}>
                {items.map(item => (
                    <option key={item._id} data-value={item._id} value={item.name}></option>
                ))}
            </datalist>
        </>
        // <Select onChange={handleChange} value={selectedId} placeholder={placeholder}>
        //     {items.map(item => (
        //         <option key={item._id} value={item._id}>{item.name}</option>
        //     ))}
        // </Select>
    )
}

export default SelectCountingAdd